import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=d1ec9a38&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "../../less/activity.less?vue&type=style&index=0&id=d1ec9a38&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1ec9a38",
  null
  
)

export default component.exports